import { Box } from '@mui/material';
import { FC } from 'react';
import LinkBarItem from '../link-bar-item';
import { getAdminBaseUrl } from '@/lib/services/auth.service';
import { useNavigate } from '@tanstack/react-router';
import useFeature from '@/hooks/use-feature.hook';
import SurepathIcon from '../../icon/surepath-icon';
import Accordion from './accordion';
import { useRouter } from '@tanstack/react-router';
import { openNewTab } from '@/lib/url-helpers';

interface Props {
  open: boolean;
  onClick: () => void;
  linkBarOpen: boolean;
}

const HomeLinkBarSection: FC<Props> = ({ open, onClick, linkBarOpen }) => {
  const navigate = useNavigate();
  const { canViewAdminUI } = useFeature();
  const router = useRouter();

  const handleClickAdminUi = () => {
    openNewTab(getAdminBaseUrl());
  };

  const handleClickCatalog = () => {
    navigate({ to: '/catalog' });
  };

  const handleClick = () => {
    navigate({ to: '/apps' });
    onClick();
  };

  const isCatalog = String(router.state.location.pathname).startsWith('/catalog');

  return (
    <Box width="100%">
      <LinkBarItem
        icon="app-switcher"
        label="Apps"
        onClick={handleClick}
        active={open}
        border={!open}
        primary={true}
        hideLabel={!linkBarOpen}
      />

      <Accordion open={open}>
        <LinkBarItem
          icon="catalog"
          label="App Catalog"
          onClick={handleClickCatalog}
          active={isCatalog}
          hideLabel={!linkBarOpen}
        />

        {canViewAdminUI && (
          <LinkBarItem
            image={<SurepathIcon />}
            label="SP Admin"
            onClick={handleClickAdminUi}
            active={false}
            hideLabel={!linkBarOpen}
          />
        )}
      </Accordion>
    </Box>
  );
};

export default HomeLinkBarSection;
